import type { TrigKey } from './keys';

export const ta: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'கணிதம் · முக்கோணவியல்',
  'panel.experiment': 'பரிசோதனை',
  'panel.params': 'அளவுருக்கள்',
  'panel.scene': 'பரிசோதனை தேர்ந்தெடு',
  'experiment.right-triangle.label': 'செங்கோண முக்கோணம்',
  'experiment.unit-circle.label': 'அலகு வட்டம்',
  'experiment.wave-studio.label': 'அலை ஸ்டுடியோ',
  'experiment.identity-playground.label': 'ஒத்தநிலைகள்',
  'experiment.triangle-solver.label': 'முக்கோண தீர்வி',
  'experiment.circular-polar.label': 'வட்டம் & துருவம்',
  'hint.line1': 'புள்ளிகளை இழு, ஸ்லைடரை நகர்த்து.',
  'hint.line2': 'கல்விப் பொருள் வடிவவியலில் வசிக்கிறது, உரையில் அல்ல.',
  'rt.angle.a': 'கோணம் A',
  'rt.angle.b': 'கோணம் B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'ரேடியன்',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° க்கு ஸ்னாப்',
  'uc.units': 'அலகுகள்',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC காட்டு',
  'uc.snap.common': 'பொதுக் கோணங்களுக்கு ஸ்னாப்',
  'uc.angle.value': '∠',
  'uc.units.deg': 'டிகி',
  'uc.units.rad': 'ரேடி',
  'uc.units.both': 'டிகி+ரேடி',
  'ws.fn': 'சார்பு',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — வீச்சு',
  'ws.frequency': 'B — அதிர்வெண்',
  'ws.phase': 'C — கட்ட இடப்பெயர்ச்சி',
  'ws.shift': 'D — செங்குத்து நகர்வு',
  'ws.rform.toggle': 'R-வடிவ வழித்தொடர்',
  'ws.rform.a': 'a (sin கெழு)',
  'ws.rform.b': 'b (cos கெழு)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'மீட்டமை',
  'ws.base': 'அடிப்படை வளைவு',
  'ip.id.pythagorean': 'பித்தகோரஸ்',
  'ip.id.reciprocal': 'மறுதலை',
  'ip.id.quotient': 'ஈவு',
  'ip.id.sum': 'கூட்டல்',
  'ip.id.difference': 'வேறுபாடு',
  'ip.id.double': 'இரட்டிப்பு',
  'ip.id.half': 'அரை',
  'ip.play': 'இயக்கு',
  'ip.pause': 'நிறுத்து',
  'ip.step': 'அடி',
  'ip.reset': 'மீட்டமை',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2 இல் — இந்த நிறுவலுக்கு விரிவான கட்டமைப்பு தேவை.',
  'ts.area': 'பரப்பு',
  'ts.sineRule': 'சைன் விதி',
  'ts.cosineRule': 'கோசைன் விதி',
  'ts.ambiguous.toggle': 'தெளிவின்மையில் பேய் முக்கோணம்',
  'ts.reset': 'சம பக்கத்துக்கு மீட்டமை',
  'ts.snap.integers': 'முழு எண்ணுக்கு ஸ்னாப்',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'பக்கங்கள்',
  'ts.section.angles': 'கோணங்கள்',
  'ts.section.sineRule': 'சைன் விதி',
  'ts.section.cosineRule': 'கோசைன் விதி',
  'ts.section.area': 'பரப்பு',
  'cp.omega': 'கோண வேகம்',
  'cp.plot.y': 'y வரை (sin)',
  'cp.plot.x': 'x வரை (cos)',
  'cp.polar.label': 'துருவ உருவம்',
  'cp.polar.circle': 'வட்டம் (r = 1)',
  'cp.polar.rose': 'ரோஸ் (r = sin 3θ)',
  'cp.polar.cardioid': 'கார்டியாய்டு (r = 1 + cos θ)',
  'cp.polar.limacon': 'லிமாசன் (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'சிறுகோண நிகர் (sin x ≈ x)',
  'cp.play': 'இயக்கு',
  'cp.pause': 'நிறுத்து',
  'cp.reset': 'மீட்டமை',
  'cp.step': 'அடி π/12',
};
